import React, { useEffect } from "react";
import PageLayout from "components/common/page-layout/page-layout";
import useCurrentUser from "hooks/use-current-user";
import { useHistory, useParams } from "react-router-dom";
import useUIState from "hooks/use-ui-state";
import { isDefined } from "helpers/predicates";
import noOp from "lib/no-op";

const Player = ({ match }) => {
  const history = useHistory();
  const { permissions } = useCurrentUser();
  const {
    ubungen,
    groupedByCategory,
    coverImg = "",
    title,
    issue = { year: "", nr: "" },
    logo
  } = permissions;
  const metadata = {
    coverImgUrl: coverImg,
    title,
    issue,
    nrUbungen: ubungen.length,
    logo: logo
  };
  const { state: uiState, setTrackId, setSwiper } = useUIState();

  const { trackId, viewType } = useParams();
  useEffect(() => {
    const urlTrackId = parseInt(trackId);

    if (isDefined(uiState.swiper)) {
      uiState.swiper.slideTo(urlTrackId, 300, noOp());
    }
    if (uiState.trackId !== urlTrackId) {
      setTrackId(urlTrackId);
    }
  }, [trackId, setTrackId, uiState.trackId, uiState.swiper]);

  return (
    <PageLayout
      metadata={metadata}
      trackId={uiState.trackId}
      match={match}
      viewType={viewType}
      history={history}
      ubungen={ubungen}
      menuItems={groupedByCategory}
      _onSwiper={(swiper) => setSwiper(swiper)}
    />
  );
};

export default Player;
